import { Component, Prop, Vue } from 'types-vue'

@Component
export default class HasBeenDownloadedColumn extends Vue {
  @Prop({ required: true })
  protected hasBeenDownloaded: boolean
}